@import '../../../../../../../constants/spacing.module.less';

.icon-error {
  color: var(--red-600);
  width: 14px;
  margin-right: @space-8;
  flex-shrink: 0;
  margin-top: 5px;
}

.icon-warning {
  color: var(--gold-500);
  width: 14px;
  margin-right: @space-8;
  flex-shrink: 0;
  margin-top: 5px;
}

.error-row-wrapper {
  display: flex;
  align-items: flex-start;
}
.error-message {
  text-align: start;
  line-height: 24px;
  font-size: 14px;
}
